module.exports = __webpack_public_path__ + "static/media/tagline.89720c79.svg";